import { Navigate, useLocation } from 'react-router-dom';
import { useAppAuth } from './AuthContext.jsx';

export default function RoleProtectedRoute({ children, allowedRoles = [] }) {
  const location = useLocation();
  const { user, ready } = useAppAuth();

  if (!ready) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return children;
}
